import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const PerformanceSlice = createSlice({
  name: 'Performances',

  initialState: {
    employeeData: [],
    PerformanceData: [],
    performanceStatusFilter: '',
    performanceSearchData: '',
    performanceSwitch: false,
    myTeamEmployees: [],
    page: 0,
    tablePageSize: 10,
    kpiTableLoader: false,
    performanceStatusCount: {
      all: 0,
      assigned: 0,
      overdue: 0,
      pending: 0,
      completed: 0,
    },
  },
  reducers: {
    setEmployeeData: (state: any, action: PayloadAction<any>) => {
      state.employeeData = action.payload;
    },
    setPerformanceData: (state: any, action: PayloadAction<any>) => {
      state.PerformanceData = action.payload;
    },
    setPerformanceSwitch: (state: any, action: PayloadAction<any>) => {
      state.performanceSwitch = action.payload;
    },
    setMyTeamEmployees: (state: any, action: PayloadAction<any>) => {
      state.myTeamEmployees = action.payload;
    },
    setPerformanceStatusFilter: (state: any, action: PayloadAction<any>) => {
      state.performanceStatusFilter = action.payload;
    },
    setPerformanceSearchData: (state: any, action: PayloadAction<any>) => {
      state.performanceSearchData = action.payload;
    },
    setPage: (state: any, action: PayloadAction<any>) => {
      state.page = action.payload;
    },
    setTablePageSize: (state: any, action: PayloadAction<any>) => {
      state.tablePageSize = action.payload;
    },
    setKpiTableLoader: (state: any, action: PayloadAction<any>) => {
      state.kpiTableLoader = action.payload;
    },
    setPerformanceStatusCount: (state: any, action: PayloadAction<any>) => {
      state.performanceStatusCount = action.payload;
    },
  },
});

export const {
  setEmployeeData,
  setPerformanceData,
  setPerformanceStatusFilter,
  setPerformanceSearchData,
  setTablePageSize,
  setPerformanceSwitch,
  setMyTeamEmployees,
  setPage,
  setKpiTableLoader,
  setPerformanceStatusCount,
} = PerformanceSlice.actions;

export default PerformanceSlice.reducer;
